import { createContext, useContext } from "react";

export interface GroupSearchCriteria {
    searchText: string;
    currentPage: number;
}

export interface GroupSearchContextParams {
    initialCriteria: GroupSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<GroupSearchCriteria>>
}

const defaultGroupSearchCriteria: GroupSearchCriteria = {
    searchText: "",
    currentPage: 1,
};

const GroupSearchContext = createContext<GroupSearchContextParams>({
    initialCriteria: defaultGroupSearchCriteria,
    setCriteria: () => {}
});

const useGroupSearch = () => {
    return useContext(GroupSearchContext);
};

export { GroupSearchContext, useGroupSearch, defaultGroupSearchCriteria };
